export const triggerEvent = (domElement, eventType) => {
    if (domElement.fireEvent) {
        domElement.fireEvent('on' + eventType);
    } else {
        const evObj = document.createEvent('Events');
        evObj.initEvent(eventType, true, false);
        domElement.dispatchEvent(evObj);
    }
};



// WEBPACK FOOTER //
// ./services/dom/eventTrigger.js